import * as math from 'mathjs';

const performMonteCarloOptimization4 = ({
    numSimulations,
    selectedAssets,
    covarianceMatrix,
    returnsArray,
    returnMin,
    ESGmin,
}) => {
    const numAssets = selectedAssets?.length || 0;
    returnMin = returnMin/100.0;
    // Initial best values
    let bestVariance = Infinity;
    let bestWeights = null;
    for (let i = 0; i < numSimulations; i++) {
        // Generate random weights and normalize them
        let weights = Array.from({ length: numAssets }, () => Math.random());
        let sumWeights = weights.reduce((sum, weight) => sum + weight, 0);
        weights = weights.map(weight => weight / sumWeights); // Normalize weights

        // Calculate portfolio return and variance
        const portfolioReturn = math.dot(weights, returnsArray);
        const portfolioVariance = math.multiply(math.multiply(weights, covarianceMatrix), math.transpose(weights));

        // Calculate ESG score
        const ESGScores = selectedAssets.map(asset =>
            asset.ESGworkforce + asset.ESGstrategy // Adjust this based on your actual ESG scoring model
        );
        const portfolioESGScore = math.dot(weights, ESGScores);

        // Check constraints: portfolio return should be above returnMin, ESG score should be above ESGmin
        if (portfolioReturn >= returnMin && portfolioESGScore >= ESGmin) {
            // If current portfolio variance is less than the best found so far, update bestVariance and bestWeights
            if (portfolioVariance < bestVariance) {
                bestVariance = portfolioVariance;
                bestWeights = weights;
            }
        }
    }

    if (bestWeights) {
        console.log("Optimized Portfolio Found with Variance:", bestVariance);
        return bestWeights;
    } else {
        return "No feasible solution meets both return and ESG requirements.";
    }
};

export default performMonteCarloOptimization4;
